import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  ticks: number;
  private sessionPopupListner = new Subject<any>();
  private timerListener = new Subject<any>();
  private sessionPopupCloseListner = new Subject<any>();

  constructor() {
    this.ticks = 0;
  }

  /**
  * Get idle time.
  *
  * @returns number
  */
  getTick() {
    return this.ticks;
  }

  /**
  * Update the idle time.
  */
  updateTick() {
    this.ticks += 1;

  }

  /**
   * Reset the idle time.
   */
  resetTick() {
      this.ticks = 0;
  }

  listenPopup(): Observable<any> {
    return this.sessionPopupListner.asObservable();
  }

  showPopup(isShow: boolean) {
    this.sessionPopupListner.next({isShow: isShow});
  }

  listenTimer(): Observable<any> {
    return this.timerListener.asObservable();
  }

  timer(value = 0) {
    this.timerListener.next({value: value});
  }

  
  listenPopupClose(): Observable<any> {
    return this.sessionPopupCloseListner.asObservable();
  }

  closePopup(isShow: boolean) {
    this.sessionPopupCloseListner.next({isShow: isShow});
  }

}
